module.exports = __webpack_public_path__ + "static/media/student-security-icon_2-color.d027eaee.svg";